import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {AddressTypesActions} from '../store';
import {AddressTypesSelectors} from '../store/selectors';
import {ApplicationState} from '../../application-state/store';

@Injectable()
export class AddressTypesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadAddressTypesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadAddressTypesDone(): Observable<boolean> {

    return this.store.pipe(
      select(AddressTypesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(AddressTypesActions.ReadAddressTypes());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
